import { render, staticRenderFns } from "./SettingsIntegrations.vue?vue&type=template&id=798f5f6e&scoped=true&"
import script from "./SettingsIntegrations.vue?vue&type=script&lang=js&"
export * from "./SettingsIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798f5f6e",
  null
  
)

export default component.exports